module.exports = __webpack_public_path__ + "img/qrcode_for_whc.f66b6925.jpg";